'use client';
import React from 'react';
import { Map } from './components';

interface GetDirectionsProps {
  address: string;
  location: [number, number] | null;
}

const Location = ({
  address,
  location,
}: GetDirectionsProps) => {
  
  if (!location || location?.length < 2) return <></>;

  return (
    <div className='sm:mt-2 rounded-2xl border border-gray-200'>
      <Map address={address} location={location}/>
    </div>
  );
}

export default Location;